const Tape7 = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 91 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" filter="url(#filter0_d_3122_16496)">
        <path
          d="M7.85237 11.9936L8.69543 9.85879C8.45769 4.69244 8.39825 3.40093 10.0173 3.32643C14.1284 3.11591 18.2455 3.32316 22.2693 3.94319C28.0457 4.85525 31.1848 4.94252 31.3036 7.52553C31.3873 9.34313 27.6811 19.5003 28.244 22.1134C28.2941 22.1071 28.3443 22.1061 28.3944 22.1001C28.7227 23.0686 29.0879 24.0583 29.3776 24.9219C31.5391 30.0372 33.7953 33.1941 38.3858 36.8956C42.9388 40.5651 48.6888 43.0914 54.6017 44.635C57.2852 45.3359 60.1247 46.1152 62.8618 46.6663C65.0122 47.1006 67.4112 46.976 69.6131 47.1142C73.8182 46.5318 78.5089 44.7329 80.4253 44.6269C81.2746 44.6022 82.0953 44.8438 82.7118 45.3C83.3284 45.7561 83.6918 46.3906 83.7243 47.0676C83.9157 51.1176 84.099 55 84.3002 59.372C84.3221 59.8792 84.1051 60.3787 83.692 60.7719C83.2789 61.1651 82.6995 61.4236 82.068 61.4965C80.8288 61.6072 78.4403 62.7034 74.5732 63.6973C72.2803 63.7303 69.6979 64.1924 67.4053 64.2318C63.7012 64.2527 60.0164 63.9221 56.4282 63.2471C52.9113 62.6331 49.3629 62.3242 45.9369 61.1761C40.3002 59.2828 34.8305 57.2061 29.8585 54.3013C26.2844 52.1708 23.0989 49.657 20.3888 46.8287C19.5203 46.0105 18.7281 44.9777 18.0374 44.3211C16.4355 42.8512 14.9815 41.2818 13.6884 39.6272C12.5401 38.137 11.5046 36.5921 10.5873 35.0004C9.48477 33.0948 8.05285 30.7034 7.4066 28.679C6.67679 26.3919 7.25532 17.0486 6.82265 15.3651C6.87927 15.3642 6.59624 13.3784 7.85237 11.9936ZM80.5819 54.9766L80.6123 54.4059C79.2628 54.4187 72.8487 56.9205 71.4992 56.9327L71.4701 57.5668L80.5819 54.9766ZM72.858 51.9738L72.9193 51.4674C72.2476 51.365 71.5755 51.2621 70.9029 51.1588C70.8478 51.3037 70.7894 51.4487 70.7364 51.5935L72.858 51.9738ZM49.7444 52.798L49.6036 53.33C51.1389 53.5454 52.6746 53.7603 54.2107 53.9747C54.2673 53.7585 54.3227 53.5423 54.3771 53.3262L49.7444 52.798ZM67.0524 61.9217C67.063 61.6557 67.0749 61.39 67.0856 61.1254C65.2175 61.0794 63.3493 61.0338 61.481 60.9887C61.4612 61.192 61.4397 61.3954 61.4199 61.5987L67.0524 61.9217ZM59.9533 55.7522L56.3072 55.3995C56.2811 55.5393 56.2537 55.6776 56.2258 55.8175C57.4391 55.9505 58.6519 56.0832 59.8643 56.2157L59.9533 55.7522ZM57.427 58.606L57.5255 58.1006L54.4704 57.7908C54.4343 57.9892 54.3962 58.1889 54.3601 58.3876L57.427 58.606ZM49.7584 56.9158C49.8634 56.7258 49.968 56.5351 50.0704 56.3449C48.7101 55.8768 47.3496 55.4096 45.9888 54.9434L45.6086 55.7788C46.991 56.1569 48.3743 56.5359 49.7584 56.9158ZM28.8117 49.0498C31.9045 50.6769 35.1603 52.2069 38.3737 53.7614C39.0076 53.2573 39.136 53.8613 39.7718 53.3598C36.4861 51.7054 33.2023 50.0529 29.7287 48.3029C29.0099 49.2127 28.5841 48.9294 28.8116 49.0481L28.8117 49.0498ZM21.2463 41.3134L21.9985 40.9448C21.2652 39.9262 20.5319 38.9081 19.7987 37.8906L19.067 38.2464C19.7934 39.2678 20.5198 40.2902 21.2463 41.3134ZM14.5828 36.0363C14.6581 36.1569 14.8989 36.2069 15.0634 36.2897L15.4955 35.571C14.9434 34.8573 14.2999 34.0238 13.6547 33.19C13.4439 33.259 13.2328 33.3298 13.0204 33.4003C13.5366 34.2798 14.0429 35.1652 14.5828 36.0363ZM14.5398 31.684L15.8924 31.0004C14.8278 29.5531 13.7633 28.1051 12.6986 26.6562L11.9765 26.9717L14.5398 31.684Z"
          fill="#E1BC58"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3122_16496"
          x="0.822632"
          y="0.246826"
          width="89.4791"
          height="72.986"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3122_16496"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3122_16496"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Tape7;
